import { render, staticRenderFns } from "./aiCourseModifyPage.vue?vue&type=template&id=3d7c8df4&scoped=true&"
import script from "./aiCourseModifyPage.vue?vue&type=script&lang=js&"
export * from "./aiCourseModifyPage.vue?vue&type=script&lang=js&"
import style0 from "./aiCourseModifyPage.vue?vue&type=style&index=0&id=3d7c8df4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d7c8df4",
  null
  
)

export default component.exports